import {
  GET_DEPARTMENT_DASHBOARD,
  GET_OKR_DASHBOARD,
  GET_TEAM_DASHBOARD,
} from '_revamp/redux/action/admin/dashboard/admin';

const initialState = {
  data: [],
  teamDashboard: [],
  departmentDashboard: [],
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_OKR_DASHBOARD: {
      return {
        ...state,
        data: payload,
      };
    }
    case GET_TEAM_DASHBOARD: {
      return {
        ...state,
        teamDashboard: payload.data,
      };
    }
    case GET_DEPARTMENT_DASHBOARD: {
      return {
        ...state,
        departmentDashboard: payload.data,
      };
    }

    default:
      return state;
  }
};

export default auth;
